"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChannelOtherState = exports.getChannelOtherText = exports.getSelectedAwarenessChannelsList = exports.getAwarenessChannelOrder = exports.getAwarenessChannelOptions = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.entries.js");

var _userAwarenessChannelConstants = _interopRequireDefault(require("./userAwarenessChannelConstants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getAwarenessChannelOptions = function getAwarenessChannelOptions(state) {
  return state.userAwareness.awarenessChannels;
};

exports.getAwarenessChannelOptions = getAwarenessChannelOptions;

var getAwarenessChannelOrder = function getAwarenessChannelOrder(state) {
  return state.userAwareness.randomAwarenessChannelsOrder;
};

exports.getAwarenessChannelOrder = getAwarenessChannelOrder;

var getSelectedAwarenessChannelsList = function getSelectedAwarenessChannelsList(state) {
  return Object.entries(getAwarenessChannelOptions(state)).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];

    return value;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key;
  });
};

exports.getSelectedAwarenessChannelsList = getSelectedAwarenessChannelsList;

var getChannelOtherText = function getChannelOtherText(state) {
  return state.userAwareness.channelOtherText;
};

exports.getChannelOtherText = getChannelOtherText;

var getChannelOtherState = function getChannelOtherState(state) {
  var isOtherSelected = getSelectedAwarenessChannelsList(state).indexOf(_userAwarenessChannelConstants.default.OTHER) !== -1;
  var channelOtherText = getChannelOtherText(state);
  return isOtherSelected && channelOtherText !== '';
};

exports.getChannelOtherState = getChannelOtherState;